import { Tournament } from '../types';
import { generateUUID } from '../lib/utils/uuid';

export interface Season {
  year: number;
  name: string;
  startDate: string;
  endDate: string;
  tournaments: {
    name: string;
    date: string;
  }[];
}

export const seasons: Season[] = [
  {
    year: 2020,
    name: '2020 Season',
    startDate: '2020-02-01',
    endDate: '2020-09-30',
    tournaments: [
      { name: 'Feb \'20 Cypress Lakes', date: '2020-02-01' },
      { name: 'Mar \'20 Kingwood GC (Forest)', date: '2020-03-01' },
      { name: 'Apr \'20 Pearland GC', date: '2020-04-01' },
      { name: 'May \'20 West Fork', date: '2020-05-01' },
      { name: 'Jun \'20 Golf Club Of Houston', date: '2020-06-01' },
      { name: 'Jul \'20 Kingwood GC (Marsh)', date: '2020-07-01' },
      { name: 'Aug \'20 Gleannloch (Pine-Glenn)', date: '2020-08-01' },
      { name: 'Sep \'20 Wildcat - Lakes', date: '2020-09-01' }
    ]
  },
  {
    year: 2021,
    name: '2021 Season',
    startDate: '2021-02-01',
    endDate: '2021-09-30',
    tournaments: [
      { name: 'Feb \'21 Cypress Lakes', date: '2021-02-01' },
      { name: 'Mar \'21 Kingwood GC (Forest)', date: '2021-03-01' },
      { name: 'Apr \'21 Pearland GC', date: '2021-04-01' },
      { name: 'May \'21 Houston National', date: '2021-05-01' },
      { name: 'Jun \'21 Golf Club Of Houston', date: '2021-06-01' },
      { name: 'Jul \'21 Golf Club Of Houston', date: '2021-07-01' },
      { name: 'Aug \'21 Eagle Pointe', date: '2021-08-01' },
      { name: 'Sep \'21 Cypress Lakes', date: '2021-09-01' }
    ]
  },
  {
    year: 2022,
    name: '2022 Season',
    startDate: '2022-02-01',
    endDate: '2022-09-30',
    tournaments: [
      { name: 'Feb \'22 Cypress Lakes', date: '2022-02-01' },
      { name: 'Mar \'22 Quail Valley (El Dorado)', date: '2022-03-01' },
      { name: 'Apr \'22 Pearland GC', date: '2022-04-01' },
      { name: 'May \'22 Windrose GC', date: '2022-05-01' },
      { name: 'Jun \'22 Golf Club Of Houston', date: '2022-06-01' },
      { name: 'Jul \'22 High Meadow Ranch', date: '2022-07-01' },
      { name: 'Aug \'22 Eagle Pointe', date: '2022-08-01' },
      { name: 'Sep \'22 Golf Club Of Houston', date: '2022-09-01' }
    ]
  },
  {
    year: 2023,
    name: '2023 Season',
    startDate: '2023-02-01',
    endDate: '2023-09-30',
    tournaments: [
      { name: 'Feb \'23 Houston National', date: '2023-02-01' },
      { name: 'Mar \'23 Wildcat - Lakes', date: '2023-03-01' },
      { name: 'Apr \'23 Cypress Lakes', date: '2023-04-01' },
      { name: 'May \'23 Windrose GC', date: '2023-05-01' },
      { name: 'Jun \'23 Golf Club Of Houston', date: '2023-06-01' },
      { name: 'Jul \'23 Wildcat - Lakes', date: '2023-07-01' },
      { name: 'Aug \'23 Eagle Pointe', date: '2023-08-01' },
      { name: 'Sep \'23 Golf Club Of Houston', date: '2023-09-01' }
    ]
  },
  {
    year: 2024,
    name: '2024 Season (Feb-Jul)',
    startDate: '2024-02-01',
    endDate: '2024-07-31',
    tournaments: [
      { name: 'Feb \'24 Quail Valley (El Dorado)', date: '2024-02-01' },
      { name: 'Mar \'24 Wildcat - Highlands', date: '2024-03-01' },
      { name: 'Apr \'24 Wilderness', date: '2024-04-01' },
      { name: 'May \'24 Sweetwater CC Cypress', date: '2024-05-01' },
      { name: 'Jun \'24 Wildcat - Lakes', date: '2024-06-01' },
      { name: 'Jul \'24 Golf Club Of Houston', date: '2024-07-01' }
    ]
  },
  {
    year: 2025,
    name: '2025 Season (Nov \'24 - Oct \'25)',
    startDate: '2024-11-01',
    endDate: '2025-10-31',
    tournaments: [
      { name: 'Nov \'24 Falcon Point', date: '2024-11-01' },
      { name: 'Dec \'24 Quail Valley (El Dorado)', date: '2024-12-01' },
      { name: 'Jan \'25 Windrose', date: '2025-01-01' }
      // Future tournaments through Oct '25 will be added
    ]
  },
  {
    year: 2026,
    name: '2026 Season (Nov \'25 - May \'26)',
    startDate: '2025-11-01',
    endDate: '2026-05-31',
    tournaments: []  // Future tournaments
  },
  {
    year: 2027,
    name: '2027 Season (Nov \'26 - May \'27)',
    startDate: '2026-11-01', 
    endDate: '2027-05-31',
    tournaments: []  // Future tournaments
  }
];

// Helper functions
export function getTournamentSeason(tournament: Tournament): Season | undefined {
  const tournamentDate = new Date(tournament.startDate);
  return seasons.find(season => {
    const startDate = new Date(season.startDate);
    const endDate = new Date(season.endDate);
    return tournamentDate >= startDate && tournamentDate <= endDate;
  });
}

export function isInCurrentSeason(tournament: Tournament): boolean {
  const currentSeason = seasons.find(s => s.year === 2025); // Current season is 2025
  if (!currentSeason) return false;

  const tournamentDate = new Date(tournament.startDate);
  const seasonStart = new Date(currentSeason.startDate);
  const seasonEnd = new Date(currentSeason.endDate);

  return tournamentDate >= seasonStart && tournamentDate <= seasonEnd;
}

export function getSeasonTournaments(year: number): Tournament[] {
  const season = seasons.find(s => s.year === year);
  if (!season) return [];
  return season.tournaments.map(t => ({
    id: generateUUID(), // Placeholder ID
    name: t.name,
    startDate: t.date,
    endDate: t.date,
    courseId: '',
    selectedTee: '',
    format: 'stroke',
    status: 'draft',
    scoringType: 'gross',
    metadata: {
      description: '',
      organizer: '',
      contactEmail: '',
      website: '',
      sponsors: [],
      notes: ''
    },
    playerLimit: 0,
    registrationDeadline: '',
    rules: ''
  }));
}